import React, { PureComponent } from 'react';
import Article from './Article';
import ImageSlider from './Sliders/ImageSlider';

class Info extends PureComponent {
  render() {
    const { match } = this.props;
    const projectId = match.params.id;

    return (
      <div>
        <ImageSlider project_id={projectId} file_path="../" />
        <Article project_id={projectId} />
      </div>
    );
  }
}

export default Info;



// WEBPACK FOOTER //
// ./src/components/Info.js